import { Box, Typography, Grid, InputLabel, TextField, Select, MenuItem, Checkbox, FormControlLabel, RadioGroup, Radio, FormControl, InputAdornment, IconButton, Button, Autocomplete, Chip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useUtiles } from '../../../../shared/context/utilesContext'
import ClassificationComponent from '../ClassificationComponent'
import TypeTaskComponent from '../TypeTaskComponent'
import AsignedComponent from '../asignedComponent'
import React, { useState, useEffect } from 'react'
import { PatternFormat } from 'react-number-format';
import { useForm, Controller } from 'react-hook-form'
import { useTaskContext } from '../../../../shared/context/taskContext'
import ClearIcon from '@mui/icons-material/Clear'
import { useRrhh } from '../../../../shared/context/rrhhContext'
export default function TaskFormComponent() {
    const theme = useTheme()
    const { priorityOptions, openSilderWith, getFirstNameAndLastName } = useUtiles()

    const [value, setValue] = useState('');
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');


    const { control, setValue: formSetValue } = useForm()
    const { task, setTask, conditions, setConditions, stepActive, handleStep, handleStepBack, isUpdateTask } = useTaskContext()

    const prevTaskRealizedRef = React.useRef(conditions.task_realized);


    const { rrhh, getRrhh } = useRrhh()
 


    const handleValueChange = (values, name) => {
        const input = values.value; // solo números, ej: "12345"
        const formatted = values.formattedValue; // ej: "123:45"
        setValue(formatted);

        const parts = formatted.split(':');
        if (parts.length === 2) {
            const minutes = parseInt(parts[1], 10);
            if (isNaN(minutes) || minutes < 0 || minutes > 59) {
                setError(true);
                setHelperText('Los minutos deben estar entre 00 y 59');
            } else {
                setError(false);
                setHelperText('');
            }
        } else {
            setError(true);
            setHelperText('Debe tener el formato HHH:MM');
        }

        setTask({ ...task, [name]: formatted })
    };


    //calcular tiempo de ejecucion
    const calculateTimeExecution = React.useCallback(() => {
        const { datetime_start, datetime_end } = task;

        if (!datetime_start || !datetime_end) {
            // console.log("calculateTimeExecution: datetime_start or datetime_end is missing", datetime_start, datetime_end);
            return null; // MODIFIED: Return null instead of empty string
        }

        const startDate = new Date(datetime_start);
        const endDate = new Date(datetime_end);

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || endDate < startDate) {
            // console.log("calculateTimeExecution: Invalid dates or endDate before startDate", startDate, endDate);
            return null; // MODIFIED: Return null instead of empty string
        }

        const diffInMillis = endDate.getTime() - startDate.getTime();
        // Total minutes should not be negative if endDate >= startDate
        const totalMinutes = Math.floor(diffInMillis / (1000 * 60));

        if (totalMinutes < 0) { // Defensive check
            // console.log("calculateTimeExecution: totalMinutes is negative", totalMinutes);
            return null; // MODIFIED: Return null instead of empty string
        }

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        const formattedHours = String(hours).padStart(3, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const result = `${formattedHours}:${formattedMinutes}`;
        // console.log(`calculateTimeExecution: Calculated ${result} from ${datetime_start} and ${datetime_end}`);
        return result;
    }, [task.datetime_start, task.datetime_end]);


    useEffect(() => {
        if (conditions.task_realized) {
            const newTimeExecution = calculateTimeExecution(); // Might be null
            if (task.time_execution !== newTimeExecution) {
                setTask(prev => ({ ...prev, time_execution: newTimeExecution }));
                formSetValue('time_execution', newTimeExecution, { shouldValidate: false, shouldDirty: true });
            }
        } else {
            // If task is not realized, clear the time_execution field
            if (task.time_execution !== null) { // MODIFIED: Check against null
                setTask(prev => ({ ...prev, time_execution: "000:00" })); // MODIFIED: Set to null
                formSetValue('time_execution', null, { shouldValidate: false, shouldDirty: false }); // MODIFIED: Set to null
            }
        }
    }, [conditions.task_realized, task.datetime_start, task.datetime_end]);



    useEffect(() => {
        // Solo resetear si cambió de false a true
        if (conditions.task_realized && !prevTaskRealizedRef.current) {
            setTask(prevTask => ({...prevTask, assigned_to: null}));
            formSetValue('assigned_to', null, { shouldValidate: false, shouldDirty: true });
        }
        prevTaskRealizedRef.current = conditions.task_realized;
    }, [conditions.task_realized, setTask, formSetValue]);



    useEffect(() => {
       setTask(prev => ({...prev, time_duration: priorityOptions.find(option => option.value === task.priority)?.time_estimate || '00:00'}))
    }, [task.priority])



    return (
        <Box>
            <Grid container spacing={2} columns={12} sx={{ marginBottom: '60px' }}>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Descripción de la tarea
                    </InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Agregue una breve descripción de la tarea
                    </Typography>
                    <Controller
                        control={control}
                        name="description"
                        rules={{ required: 'La descripción es requerida' }}
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Ingrese la descripción de la tarea"                               
                                value={task.description || ""}
                                error={!task.description}
                                helperText={!task.description ? 'La descripción es requerida' : ''}
                                onChange={(e) => setTask({ ...task, description: e.target.value })}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Notas
                    </InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Agregue notas adicionales sobre la tarea
                    </Typography>
                    <Controller
                        control={control}
                        name="note"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                multiline
                                rows={4}
                                placeholder="Ingrese notas adicionales"
                                value={task.note || ""}
                                onChange={(e) => setTask({ ...task, note: e.target.value })}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Tipo de tarea
                    </InputLabel>
                    <Controller
                        control={control}
                        name="typeTask"
                        rules={{ required: 'El tipo de tarea es requerido' }}
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Seleccione el tipo de tarea"

                                InputProps={{
                                    readOnly: true,
                                    endAdornment: task.typeTask && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTask({ ...task, typeTask: null });
                                                }}
                                                size="small"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                onClick={() => openSilderWith(
                                    <TypeTaskComponent />,
                                    500,
                                    'Tipo de tarea'
                                )}
                           
                                value={task.typeTask?.value || ''}
                                error={!task.typeTask}
                                helperText={!task.typeTask ? 'El tipo de tarea es requerido' : ''}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Classificacion 1
                    </InputLabel>
                    <Controller
                        control={control}
                        name="classification_1"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Seleccione la clasificación 1 de la tarea"

                                InputProps={{
                                    readOnly: true,
                                    endAdornment: task.classification_1 && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTask({ ...task, classification_1: null });
                                                }}
                                                size="small"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                onClick={() => openSilderWith(
                                    <ClassificationComponent number={1} />,
                                    500,
                                    'Clasificación 1'
                                )}
                               
                                value={task.classification_1?.value || ''}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Classificacion 2
                    </InputLabel>
                    <Controller
                        control={control}
                        name="classification_2"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Seleccione la clasificación 2 de la tarea"

                                InputProps={{
                                    readOnly: true,
                                    endAdornment: task.classification_2 && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTask({ ...task, classification_2: null });
                                                }}
                                                size="small"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                onClick={() => openSilderWith(
                                    <ClassificationComponent number={2} />,
                                    500,
                                    'Clasificación 2'
                                )}
                               
                                value={task.classification_2?.value || ''}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Prioridad
                    </InputLabel>
                    <FormControl fullWidth>
                        <Controller
                            control={control}
                            name="priority"
                            render={({ field }) => (
                                <Select
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Seleccione la prioridad de la tarea"
                                    {...field}
                                    value={task.priority || ''}
                                    onChange={(e) => setTask({ ...task, priority: e.target.value })}
                                >
                                    {priorityOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.icon}
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Plazo de atención (horas : minutos)
                    </InputLabel>
                    <Controller
                        control={control}
                        name="time_duration"
                        render={({ field }) => (
                            <PatternFormat
                                disabled={conditions.task_realized}
                                value={task.time_duration}
                                format="###:##"
                                mask="_"
                                allowEmptyFormatting
                                customInput={TextField}
                                fullWidth
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>


               {/* <Grid item size={{ xs: 12 }}>
                    <Controller
                        control={control}
                        name="task_realized"
                        render={({ field }) => (
                            <FormControlLabel
                                control={<Checkbox
                                    fullWidth
                                    variant="outlined"
                                    {...field}
                                    checked={conditions.task_realized}
                                    disabled={isUpdateTask}
                                    onChange={(e) => {
                                        const conditionsNew = {
                                            task_realized: false,
                                            send_to: "pending",
                                        }
                                        if (e.target.checked) {
                                            conditionsNew['task_realized'] = true
                                            conditionsNew['send_to'] = "close"

                                        } else {
                                            conditionsNew['send_to'] = "pending"
                                        }
                                        setConditions(prev => ({ ...prev, ...conditionsNew }))
                                    }}
                                />}
                                label="¿Este trabajo ya fue realizado?"
                            />
                        )}
                    />

                </Grid> */}

                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Opciones
                    </InputLabel>
                    <Controller
                        control={control}
                        name="send_to"
                        render={({ field }) => (
                            <RadioGroup row
                                {...field}
                                value={conditions.send_to}
                                onChange={(e) => setConditions({ ...conditions, send_to: e.target.value })}
                            >
                                {!conditions.task_realized && (
                                    <>
                                        <FormControlLabel
                                            control={<Radio />}
                                            label="Enviar a tareas pendientes"
                                            value="pending"
                                        />
                                        <FormControlLabel
                                            control={<Radio />}
                                            label="Enviar a OTs en Proceso"
                                            value="in_process"
                                            disabled={isUpdateTask}
                                        />
                                    </>
                                )}

                                {conditions.task_realized && (
                                    <>
                                        <FormControlLabel
                                            control={<Radio />}
                                            label="En Revisión"
                                            value="review"
                                        />
                                        <FormControlLabel
                                            control={<Radio />}
                                            label="Finalizadas"
                                            value="close"
                                        />
                                    </>
                                )}
                            </RadioGroup>
                        )}
                    />

                </Grid>

                {(conditions.task_realized || conditions.send_to === "in_process") && 
                <>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Responsable
                    </InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Seleccione el responsable de la tarea
                    </Typography>
                    <Controller
                        control={control}
                        name="assigned_to"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                        startAdornment: task.assigned_to && (
                                            <InputAdornment position="start">
                                                <Box sx={{
                                                    mr: 1,
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    bgcolor: 'primary.light',
                                                    color: 'white',
                                                    overflow: 'hidden'
                                                }}>
                                                    {task.assigned_to.avatar ? (
                                                        <img
                                                            src={task.assigned_to.avatar}
                                                            alt={task.assigned_to.fullName}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    ) : (
                                                        <Box sx={{ fontSize: 14 }}>
                                                            {task.assigned_to.fullName.charAt(0).toUpperCase()}
                                                        </Box>
                                                    )}
                                                </Box>
                                            </InputAdornment>
                                        )
                                    }
                                }}

                                onClick={() => {
                                    console.log('Task assigned_to:', task.assigned_to); // Debug log
                                    openSilderWith(
                                        <AsignedComponent />,
                                        500,
                                        'Asignar responsable'
                                    );
                                }}
                              
                                value={task.assigned_to?.fullName || ''}
                                error={!task.assigned_to}
                                helperText={!task.assigned_to ? 'El responsable es requerido' : ''}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Apoyo técnico extra (Opcional)
                    </InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Seleccione el apoyo técnico extra para la tarea
                    </Typography>

                    <Controller
                        control={control}
                        name="extra_technical_support"
                        render={({ field }) => (
                            <Autocomplete
                                multiple
                                fullWidth
                                variant="outlined"
                                options={rrhh || []}
                                onInputChange={(e, value) => {
                                    getRrhh({ 
                                        exclude: task.assigned_to?.num_document,
                                        fullName: value,
                                        user_task_attender: true
                                    });
                                }}
                                onOpen={() => getRrhh({ exclude: task.assigned_to?.num_document, user_task_attender: true })}
                                getOptionLabel={(option) => option?.fullName ? `${option.fullName} - ${option.num_document}` : ''}
                                isOptionEqualToValue={(option, value) => option?.num_document === value?.num_document}
                                onChange={(e, newValue) => {
                                    setTask(prevTask => ({
                                        ...prevTask,
                                        extra_technical_support: newValue || []
                                    }));
                                }} 
                                value={Array.isArray(task.extra_technical_support) ? task.extra_technical_support : []}
                                renderInput={(params) => (
                                    <TextField 
                                        {...params} 
                                        placeholder="Seleccione el apoyo técnico extra" 
                                    />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            label={`${getFirstNameAndLastName(option.fullName)}`}
                                            {...getTagProps({ index })}
                                            avatar={
                                                <Box
                                                    sx={{
                                                        width: 24,
                                                        height: 24,
                                                        bgcolor: theme.palette.primary.main,
                                                        color: '#ffffff !important',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    { option.fullName.charAt(0).toUpperCase()}
                                                </Box>
                                            }
                                        />
                                    ))
                                }
                            />
                        )}
                    />

                </Grid>
                </>
                }


                {!conditions.task_realized && <Grid item size={{ xs: 12, md: 4 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                        Fecha programada
                    </InputLabel>
                    <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                        Agregue la fecha programada para la tarea
                    </Typography>
                    <Controller
                        control={control}
                        name="datetime_start_estimated"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                variant="outlined"
                                type="datetime-local"
                               
                                value={task.datetime_start_estimated || ''}
                                onChange={(e) => setTask({ ...task, datetime_start_estimated: e.target.value })}
                            />
                        )}
                    />
                </Grid>}


                {
                    conditions.task_realized &&
                    <>
                        <Grid item size={{ xs: 12, md: 4 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                                Fecha de Inicio
                            </InputLabel>
                            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                Agregue la fecha de inicio para la tarea
                            </Typography>
                            <Controller
                                control={control}
                                name="datetime_start"
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        type="datetime-local"
                                      
                                        value={task.datetime_start || ''}
                                        onChange={(e) => setTask({ ...task, datetime_start: e.target.value })}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                                Fecha de finalización
                            </InputLabel>
                            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                Agregue la fecha de finalización para la tarea
                            </Typography>
                            <Controller
                                control={control}
                                name="datetime_end"
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        type="datetime-local"
                                      
                                        value={task.datetime_end || ''}
                                        onChange={(e) => setTask({ ...task, datetime_end: e.target.value })}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                                Tiempo de Ejecución
                            </InputLabel>
                            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                El tiempo se calcula en horas y minutos automáticamente
                            </Typography>
                            <Controller
                                control={control}
                                name="time_execution"
                                render={({ field }) => (
                                    <PatternFormat
                                        onValueChange={(values) => handleValueChange(values, 'time_execution')}
                                        format="###:##"
                                        mask="_"
                                        allowEmptyFormatting
                                        customInput={TextField}
                                        fullWidth
                                        variant="outlined"
                                        value={task.time_execution || ''}
                                        error={error}
                                        helperText={helperText}
                                        slotProps={{
                                            input: {
                                                readOnly: true,
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </>

                }

                
            </Grid>



            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px', position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
                <Button
                    variant="contained"
                    onClick={handleStepBack}
                    disabled={stepActive === 1}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Anterior
                </Button>

                <Button
                    variant="contained"
                    onClick={handleStep}
                    disabled={!task.description || !task.typeTask || (conditions.task_realized && !task.assigned_to) || (conditions.send_to === "in_process" && !task.assigned_to)}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Siguiente
                </Button>
            </Box>



        </Box>
    )
}